/**
 * Свежесть бандла в открытой вкладке.
 *
 * **Зачем.** Записи «Что нового», тексты и правила живут В БАНДЛЕ, а вкладку
 * кабинета не закрывают неделями. Значит человек с открытой вкладкой не увидит
 * ни новой записи, ни исправленного текста до тех пор, пока сам не перезагрузит
 * страницу, а повода перезагружать у него нет.
 *
 * ⚠️ **Чинится это версией сборки, а НЕ сроком сессии.** Мысль «убивать сессию
 * через час простоя, чтобы вкладка обновилась» разобрана и отвергнута
 * 21.08.2026 (`docs/whats-new-design.md`): смерть сессии не выгоняет старый JS
 * из открытой вкладки, она превращает его запросы в 401. То есть человек не
 * получает свежий интерфейс, он получает выкидывание на форму входа, и в первую
 * очередь его получает ученик, который час молча решал упражнения. Сроки
 * гостевой сессии (60 суток простоя, 180 суммарно) это решение владельца из
 * раздела 5.10 CLAUDE.md, и на нём держится вход по ссылке без аккаунта.
 *
 * Чистые функции без React и без сети: файл попадает в `node --test`.
 */

/**
 * Версия бандла, впечённая сборкой. `undefined` означает «не знаем».
 *
 * ⚠️ Читать `__BUILD_ID__` голой ссылкой нельзя, иначе падают тесты: в
 * `node --test` подстановки Vite нет, и обращение к необъявленному имени
 * роняет модуль. Предупреждение стоит и в `src/vite-env.d.ts`.
 *
 * ⚠️ **`"dev"` это тоже «не знаем», а не версия.** Умолчание `EDU_BUILD_ID ??
 * "dev"` стоит в `vite.config.ts`, то есть в деве и в любой локальной сборке
 * без переменной сюда приезжает эта строка. Сравнивать её с настоящим хешем
 * нельзя: локально собранный бандл рядом с чужим `config.json` дал бы вечную
 * полосу «обновите страницу», которую перезагрузка не убирает, потому что
 * версия бандла от перезагрузки не меняется.
 */
export function localBuildId(): string | undefined {
  if (typeof __BUILD_ID__ !== "string") return undefined;
  return __BUILD_ID__ === "dev" ? undefined : __BUILD_ID__;
}

/**
 * Устарела ли вкладка.
 *
 * ⚠️ Истина только когда ОБЕ версии известны и различны. Неизвестность это
 * молчание: в деве версия «dev» и сравнивать нечего, у старого `config.json`
 * поля нет вовсе, а отказ сети не должен превращаться в полосу «обновите». Цена
 * ошибки несимметрична: лишняя полоса это ложная тревога на всех экранах
 * кабинета, а пропущенная это ровно то состояние, в котором люди жили до сих пор.
 */
export function isStaleBuild(
  local: string | undefined,
  server: string | undefined,
): boolean {
  if (local === undefined || server === undefined) return false;
  return local !== server;
}
